import React, { useState } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  Platform,
  ViewStyle,
  TextStyle,
} from 'react-native';
import { useTheme } from '../context/themeContext';
import Icon from './icon';

interface MenuItemProps {
  icon?: string;
  children?: React.ReactNode;
  onPress?: () => void;
  danger?: boolean;
  checked?: boolean;
  style?: ViewStyle;
}

export default function MenuItem({
  icon,
  children,
  onPress,
  danger = false,
  checked = false,
  style,
}: MenuItemProps) {
  const { theme } = useTheme();
  const { colors, fontSize, fontWeight, radii } = theme;
  const [hovered, setHovered] = useState(false);

  const bg = hovered
    ? danger
      ? colors.dangerSoft
      : colors.paper2
    : 'transparent';

  const textColor = danger ? colors.danger : hovered ? colors.ink : colors.ink2;

  const containerStyle: ViewStyle = {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderRadius: radii.r2,
    backgroundColor: bg,
    ...Platform.select({
      web: {
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'background 80ms, color 80ms',
        whiteSpace: 'nowrap',
      } as ViewStyle,
      default: {},
    }),
  };

  const labelStyle: TextStyle = {
    flex: 1,
    fontSize: fontSize.md,
    color: textColor,
    fontFamily: theme.font.sans,
    fontWeight: fontWeight.regular,
    includeFontPadding: false,
  };

  const webHandlers = Platform.OS === 'web'
    ? {
        onMouseEnter: () => setHovered(true),
        onMouseLeave: () => setHovered(false),
      }
    : {};

  return (
    <TouchableOpacity
      style={[containerStyle, style]}
      onPress={onPress}
      activeOpacity={0.75}
      {...(webHandlers as any)}
    >
      {icon && (
        <Icon name={icon} size={15} color={textColor} />
      )}
      {typeof children === 'string' ? (
        <Text style={labelStyle}>{children}</Text>
      ) : (
        <View style={{ flex: 1 }}>{children}</View>
      )}
      {checked && (
        <Icon name="check" size={14} color={colors.accent} />
      )}
    </TouchableOpacity>
  );
}

export function MenuSeparator() {
  const { theme } = useTheme();
  return (
    <View
      style={{
        height: 1,
        backgroundColor: theme.colors.line,
        marginVertical: 5,
      }}
    />
  );
}
